import CustomModal from '@islands/custom-modal';

class ModalToggle extends HTMLElement {
  modal: CustomModal | null = null;
  toggleBtn: HTMLElement | null = null;

  connectedCallback() {
    this.toggleBtn = this.querySelector('[id*="-toggle"]');
    const modalTarget = this.getAttribute('data-target');
    this.modal = modalTarget ? (document.querySelector(modalTarget) as CustomModal | null) : null;

    this.toggleBtn?.addEventListener('click', () => {
      if (!this.modal) return;

      // Resolve attributes from host first, then fallback to inner toggle button
      const hostTitle = this.getAttribute('data-modal-title') || '';
      const btnTitle = this.toggleBtn?.getAttribute('data-modal-title') || '';
      const titleAttr = hostTitle || btnTitle;

      const hostContentId = this.getAttribute('data-modal-content-id') || '';
      const btnContentId = this.toggleBtn?.getAttribute('data-modal-content-id') || '';
      const contentIdAttr = hostContentId || btnContentId;

      // Normalize selector: allow passing an id without '#', or a full selector
      let selector = (contentIdAttr || '').trim();
      if (selector && !selector.startsWith('#') && !selector.startsWith('.')) {
        selector = `#${selector}`;
      }

      let content = '';
      if (selector) {
        const sourceEl = document.querySelector(selector) as HTMLElement | null;
        if (sourceEl) {
          content = sourceEl.innerHTML || '';
        }
      }

      // Set modal title and content
      const titleEl = this.modal.querySelector('[data-modal-title]');
      if (titleEl) titleEl.textContent = titleAttr;

      const contentEl = this.modal.querySelector('[data-modal-content]');
      if (contentEl) contentEl.innerHTML = content;

      // Show modal
      this.modal.show();
    });
  }
}

if (!customElements.get('modal-toggle')) {
  window.customElements.define('modal-toggle', ModalToggle);
}
